if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(196|334|818)|2(51[29]|036|354|376|858|874)|3(50(|2)|6(34|70|84)|014|100|778|932|956)|4(030|317|737|782|93)|5(478|50|874)|6((03|11|69|7)8|24|296|386|460)|7(014|196|672|806|918)|8(45[04]|038|050|198|312|542|86)|9(11[04]|(03|29|30)6|362|50))$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}